import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { removeSnackbar } from 'dux/notifications/actionCreators';

import SnackbarNotifier from './SnackNotifier';

const mapStateToProps = (store) => ({
  notifications: store.notifications.notifications,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ removeSnackbar }, dispatch);

export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(SnackbarNotifier));
